$(document).on('beforeSubmit', '.bn_spinner__form', function() {
    let that = $(this),
        submit = that.find('.bn_spinner__submit')

    submit.attr('disabled', true);
    submit.addClass('spin');
});

$(document).on('click', '.bn_spinner__fire', function () {
    let that = $(this);

    that.attr('disabled', true);
    that.addClass('spin');
});